{
    "WebexAuth_UserIntro": "Salut **{}**,",
    "WebexAuth_UserIntro_2": "CX Analytics demande l'accès à votre locataire Webex Calling.",
    "WebexAuth_AdminConsent": "Consentement de l'administrateur de la subvention",
    "WebexAuth_Authorise": "Autoriser",
    "WebexAuth_ConsentedMessage": "Autorisation de l'administrateur accordée, veuillez cliquer sur Autoriser pour continuer",
    "WebexAuth_AuthorisedMessage": "Autorisation accordée",
    "WebexAuth_Decline": "Déclin",
    "WebexAuth_Error_Unknown": "Une erreur non identifiée s'est produite. Veuillez réessayer. Si le problème persiste, veuillez contacter votre administrateur système.",
    "NAME": "WebexAuthLanguage"
}